/** @file Link button that navigates to the tenant search list. */
import * as tsx from 'vue-tsx-support';
import * as icons from '@codegrade/icons';
import { Icon } from '@/components/Icon';
import { clsButtonLikeLink } from './cls';
import { routeTenantList } from './routes';
/** Button link to the institution search page. */
export const GotoTenantListLink = tsx.component({
    name: 'goto-tenant-list-link',
    /** @returns The rendered tenant list link JSX. */
    render() {
        return (<router-link data-cy="goto-tenant-list" class={clsButtonLikeLink} to={routeTenantList(this.$router)}>
                Search for your institution
                <Icon icon={icons.ArrowRight}/>
            </router-link>);
    },
});
